import { ReactNode, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

interface PageTransitionProps {
  children: ReactNode;
}

export const PageTransition = ({ children }: PageTransitionProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Hide content immediately on location change
    setIsVisible(false);
    
    // Show content after a brief delay
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 350); // Perfect middle ground between 300ms and 400ms

    return () => clearTimeout(timer);
  }, [location]);

  return (
    <div
      className={`transition-opacity duration-700 ease-in-out ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
      style={{
        transition: 'opacity 700ms cubic-bezier(0.4, 0, 0.2, 1)',
        backgroundColor: 'white'
      }}
    >
      {children}
    </div>
  );
}; 